import { render, staticRenderFns } from "./product-recommend.vue?vue&type=template&id=7db48944&"
import script from "./product-recommend.vue?vue&type=script&lang=js&"
export * from "./product-recommend.vue?vue&type=script&lang=js&"
import style0 from "./product-recommend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VExpandTransition})
